var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-map',{staticStyle:{"width":"100%","height":"680px"},attrs:{"zoom":_vm.zoom,"crs":_vm.crs,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"subdomains":_vm.subdomains,"options":_vm.tileLayerOptions,"tms":true}}),_c('l-marker',{attrs:{"lat-lng":_vm.marker,"icon":_vm.addressIcon,"attribution":_vm.attribution}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }